import { pickLocalizedText, type LocalizedText } from './uiLocale'

const copy = {
  selection: { es: 'Selección', en: 'Selection' },
  seat: { es: 'Asiento', en: 'Seat' },
  refPrefix: { es: 'Ref.', en: 'Ref.' },
  chooseModules: { es: 'Elegir módulos', en: 'Choose modules' },
  chooseFabricAndColor: { es: 'Elegir tejido y color', en: 'Choose fabric and color' },
  backToPrincipal: { es: 'Volver a Principal', en: 'Back to Main' },
  searchByWidth: { es: 'Buscar por ancho...', en: 'Search by width...' },
  search: { es: 'Buscar...', en: 'Search...' },
  searchingModules: { es: 'Buscando módulos...', en: 'Searching modules...' },
  noResultsFound: { es: 'No se encontraron resultados', en: 'No results found' },
  showDimensions: { es: 'Mostrar cotas', en: 'Show dimensions' },
  hideDimensions: { es: 'Ocultar cotas', en: 'Hide dimensions' },
  saveProject: { es: 'Guardar el proyecto', en: 'Save project' },
  createNewProject: { es: 'Crea un nuevo proyecto', en: 'Create a new project' },
  undo: { es: 'Deshacer', en: 'Undo' },
  redo: { es: 'Rehacer', en: 'Redo' },
  duplicateFurniture: { es: 'Duplicar mueble', en: 'Duplicate unit' },
  delete: { es: 'Eliminar', en: 'Delete' },
  group: { es: 'Grupo', en: 'Group' },
  groupOpen: { es: 'Grupo abierto', en: 'Group open' },
  groupClosed: { es: 'Grupo cerrado', en: 'Group closed' },
  unnamed: { es: 'Sin nombre', en: 'Unnamed' },
  loadingTextures: { es: 'Cargando texturas...', en: 'Loading textures...' },
  loadingFinishes: { es: 'Cargando acabados...', en: 'Loading finishes...' },
  noFinishes: { es: 'No hay acabados para este linkedItem', en: 'No finishes for this linked item' },
  date: { es: 'Fecha', en: 'Date' },
  model: { es: 'Modelo', en: 'Model' },
  characteristics: { es: 'Características', en: 'Characteristics' },
  reference: { es: 'Referencia', en: 'Reference' },
  fabric: { es: 'Tejido', en: 'Fabric' },
  fabricCharacteristics: { es: 'Características tejido:', en: 'Fabric characteristics:' },
  totalPrice: { es: 'Precio total:', en: 'Total price:' },
  total: { es: 'Precio total desde:', en: 'Total price from:' },
  print: { es: 'Imprimir', en: 'Print' },
  download: { es: 'Descargar', en: 'Download' },
  budget: { es: 'Presupuesto', en: 'Budget' },
  currentScene: { es: 'Escena actual', en: 'Current scene' },
  noCapture: { es: 'Sin captura disponible', en: 'No capture available' },
  withPhoto: { es: '(con su foto)', en: '(with its photo)' },
  dimLargo: { es: 'L', en: 'L' },
  dimFondo: { es: 'F', en: 'D' },
  dimAlto: { es: 'A', en: 'H' },
  budgetLargo: { es: 'largo', en: 'length' },
  budgetFondo: { es: 'fondo', en: 'depth' },
  budgetAlto: { es: 'alto', en: 'height' },
  catalogLargo: { es: 'Largo', en: 'Length' },
  catalogFondo: { es: 'Fondo', en: 'Depth' },
  catalogAlto: { es: 'Alto', en: 'Height' },
  and: { es: 'y', en: 'and' },
  artisan1: {
    es: 'Estructura reforzada con espuma de alta densidad.',
    en: 'Reinforced structure with high-density foam.',
  },
  artisan2: {
    es: 'Relleno Plumifill Eco® antialérgico y reciclable.',
    en: 'Plumifill Eco® hypoallergenic and recyclable filling.',
  },
  artisan3: {
    es: 'Tapizado desenfundable.',
    en: 'Removable upholstery.',
  },
} as const satisfies Record<string, LocalizedText>

export type UiCopyKey = keyof typeof copy

export function ui(key: UiCopyKey): string {
  return pickLocalizedText(copy[key])
}

export function getDimensionAbbrevLabels() {
  return {
    largo: ui('dimLargo'),
    fondo: ui('dimFondo'),
    alto: ui('dimAlto'),
  }
}

export function getBudgetDimensionWordLabels() {
  return {
    largo: ui('budgetLargo'),
    fondo: ui('budgetFondo'),
    alto: ui('budgetAlto'),
  }
}

/** Etiquetas del menú: Largo/Fondo/Alto (ES) o Length/Depth/Height (EN). */
export function getCatalogDimensionLabels() {
  return {
    largo: ui('catalogLargo'),
    fondo: ui('catalogFondo'),
    alto: ui('catalogAlto'),
  }
}

export function getArtisanCharacteristics(): string[] {
  return [ui('artisan1'), ui('artisan2'), ui('artisan3')]
}
